import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';
import { Video } from '@pages/home/cats/Video';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: 'f4c975cb-a15b-43da-b06f-d651b298ae4b',
	[LanguageEnum.SK]: 'f4c975cb-a15b-43da-b06f-d651b298ae4b',
	default: 'f4c975cb-a15b-43da-b06f-d651b298ae4b'
}


export const AdvantagesProbe = () => {

	return (
		<MdxDiv className='advantages' articleIds={articleIds} childrenBeforeMd={<Video />}>
		</MdxDiv>
	);
};